import { useMutation, useQueryClient } from '@tanstack/react-query';
import { keys } from '@/lib/queryKeys';
import { createOpdBill } from './api';

export function useCreateOpdBill() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createOpdBill,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.billing.list() });
    },
  });
}
